import { reactive, ref, watch } from '@vue/composition-api'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import useVendorMap from './useVendorMap'

export default function useAddVendor(ctx) {
  const vendorFormRef = ref(null)
  const vendor = reactive({
    batchPrefix: '',
    name: '',
    sequencePrefix: '',
    emails: '',
    vendorType: '',
    pointOfContact: '',
    phoneNumber: null,
    maxChargeAmount: null,
    additionalData: {
      locations: [],
    },
  })
  const submitBtnLoading = ref(false)
  const addVendor = async () => {
    const valid = await vendorFormRef.value.validate()
    if (valid) {
      try {
        submitBtnLoading.value = true
        vendor.additionalData.locations = vendor.additionalData.locations.map(loc => (
          {
            lat: loc.lat,
            lon: loc.lng,
          }
        ))
        await ctx.root.$store.dispatch('vendors/addVendor', vendor)
        successNotification('Added successfully')
        ctx.root.$router.push('/vouchers/vendors')
      } catch (err) {
        console.log('err', err)
        if (err?.response?.status === 422) {
          errorNotification('Entered vendor type is not a valid enumeration member')
        }
      } finally {
        submitBtnLoading.value = false
      }
    }
  }
  const { locations } = useVendorMap()

  watch(locations, () => {
    vendor.additionalData.locations = locations
  })
  return {
    addVendor,
    vendor,
    vendorFormRef,
    submitBtnLoading,
  }
}
